import Xt from "../models/backend-errors.js";
import De from "../models/braze-event.js";
import {
  convertMsToSeconds as X,
  convertSecondsToMs as Yt,
} from "../util/date-utils.js";
import v from "../common/event-logger.js";
import { isArray as R, isEqual as ni } from "../util/code-utils.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import h from "../util/request-header-utils.js";
import {
  LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT as Qt,
  MAX_RETRY_COUNT_PER_REQUEST as Zt,
} from "../common/constants.js";
import { getAlias as qe } from "./utils.js";
import { readResponseHeaders as Ae } from "../util/net.js";
export default class Mt {
  constructor(t, e, i, s, r, n, o, a, h, u, l, c) {
    (this.eu = t),
      (this.B = e),
      (this.hl = i),
      (this.vs = s),
      (this.C = r),
      (this.h = n),
      (this.tu = o),
      (this.al = a),
      (this.sl = h),
      (this.rl = u),
      (this.appVersion = l),
      (this.vl = c),
      (this.Rl = (t) => (null == t ? "" : `${t} `)),
      (this.eu = t),
      (this.B = e),
      (this.hl = i),
      (this.vs = s),
      (this.C = r),
      (this.h = n),
      (this.tu = o),
      (this.al = a),
      (this.sl = h),
      (this.rl = u),
      (this.appVersion = l),
      (this.vl = c),
      (this.bl = ["npm"]),
      (this.ql = {});
  }
  $(t, e = !1, i = !1) {
    const r = this.eu.ve(!i),
      n = r.Hn(),
      o = this.B.dt(s.ft.ac);
    ni(o, n) || (t.device = n),
      (t.api_key = this.tu),
      (t.time = X(new Date().valueOf(), !0));
    const a = this.B.dt(s.ft.Dl) || [],
      h = this.B.dt(s.ft.Tl) || "";
    this.bl.length > 0 &&
      (!ni(a, this.bl) || h !== this.C.yt()) &&
      (t.sdk_metadata = this.bl),
      (t.sdk_version = this.sl),
      this.rl && (t.sdk_flavor = this.rl),
      (t.app_version = this.appVersion),
      (t.app_version_code = this.vl),
      (t.device_id = r.id);
    const u = this.vs.getUserId();
    if ((e && null !== u && (t.user_id = u), !u && !this.hl.wh())) {
      const e = qe(this.B);
      e && (t.alias = e);
    }
    return t;
  }
  Y(t, e, i) {
    const s = e.auth_error,
      r = e.error;
    if (!s && !r) return !0;
    if (s) {
      let e;
      this.hl.Hh();
      const r = { errorCode: s.error_code };
      for (const t of i)
        R(t) && "X-Braze-Auth-Signature" === t[0] && (r.signature = t[1]);
      t.respond_with && t.respond_with.user_id
        ? (r.userId = t.respond_with.user_id)
        : t.user_id && (r.userId = t.user_id);
      const n = s.reason;
      return (
        n
          ? ((r.reason = n), (e = `due to ${n}`))
          : (e = `with error code ${s.error_code}.`),
        this.hl.wh() ||
          (e +=
            ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'),
        E.error(`SDK Authentication failed ${e}`),
        this.kl(t.events || [], t.attributes || []),
        this.hl.Bh(r),
        !1
      );
    }
    if (r) {
      let i,
        s = r;
      switch (s) {
        case Xt.yl:
          return (
            (i = "Received successful response with empty body."),
            v.lt(f.wl, { e: i }),
            E.info(i),
            !1
          );
        case Xt.Cl:
          return (
            (i = "Received successful response with invalid JSON"),
            v.lt(f.wl, { e: i + ": " + e.response }),
            E.info(i),
            !1
          );
        case Xt.Bl:
          s = `The API key "${t.api_key}" is invalid for the baseUrl ${this.al}`;
          break;
        case Xt.zl:
          s =
            "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
          break;
        case Xt.jl:
          s = "No device identifier. Please contact support@braze.com";
      }
      E.error("Backend error: " + s);
    }
    return !1;
  }
  Ml(t, e, i) {
    return !!((t && 0 !== t.length) || (e && 0 !== e.length) || i);
  }
  $l(t, e, i, s = !1) {
    const r = [],
      n = (t) => t || "",
      o = n(this.vs.getUserId());
    let a = this.Xn(t);
    const u = [],
      l = [];
    let c,
      d = null;
    if (e.length > 0) {
      const t = [];
      for (const i of e) {
        if (((c = i.Hn()), this.hl.wh())) {
          if (o && !c.user_id) {
            d || (d = {}), d.events || (d.events = []), d.events.push(c);
            continue;
          }
          if (n(c.user_id) !== o) {
            l.push(c);
            continue;
          }
        }
        t.push(c);
      }
      t.length > 0 && (a.events = t);
    }
    if (i.length > 0) {
      const t = [];
      for (const e of i)
        e && (this.hl.wh() && n(e.user_id) !== o ? u.push(e) : t.push(e));
      t.length > 0 && (a.attributes = t);
    }
    if ((this.kl(l, u), (a = this.$(a, !1, s)), d)) {
      d = this.$(d, !1, s);
      const t = { requestData: d, headers: this.A(d, h.H.Ze) };
      r.push(t);
    }
    if (a && !this.Ml(a.events, a.attributes, t)) return d ? r : null;
    const f = { requestData: a, headers: this.A(a, h.H.Ze) };
    return r.push(f), r;
  }
  kl(t, e) {
    if (t) {
      const e = [];
      for (const i of t) {
        const t = De.fromJson(i);
        (t.time = Yt(t.time)), e.push(t);
      }
      this.B.ol(e);
    }
    if (e) for (const t of e) this.B.Xl(t);
  }
  _(t, e) {
    let i = "HTTP error ";
    null != t && (i += t + " "), (i += e), E.error(i);
  }
  Ll(t) {
    return v.lt(f.Fl, { n: t });
  }
  Xn(t, e) {
    const i = {};
    t && (i.triggers = !0);
    const s = null != e ? e : this.vs.getUserId();
    if ((s && (i.user_id = s), !i.user_id && !this.hl.wh())) {
      const t = qe(this.B);
      t && (i.alias = t);
    }
    return (i.config = { config_time: this.h.xt() }), { respond_with: i };
  }
  Kl(t) {
    const e = new Date().valueOf();
    let i = Qt.toString();
    const s = h.Pl(this.B, t);
    if (-1 !== s) {
      i = (e - s).toString();
    }
    return i;
  }
  A(t, e, i = !1) {
    const s = [["X-Braze-Api-Key", this.tu]],
      r = this.Kl(e);
    s.push(["X-Braze-Last-Req-Ms-Ago", r]);
    const n = h.Ul(this.B, e).toString();
    s.push(["X-Braze-Req-Attempt", n]);
    let o = !1;
    if (
      (null != t.respond_with &&
        t.respond_with.triggers &&
        (s.push(["X-Braze-TriggersRequest", "true"]), (o = !0)),
      e === h.H.vi)
    ) {
      s.push(["X-Braze-ContentCardsRequest", "true"]);
      let t = h.Ul(this.B, h.H.vi);
      (t && !i) || ((t = 1), h.xl(this.B, h.H.vi, t));
      const e = Math.max(0, t - 1);
      s.push(["BRAZE-SYNC-RETRY-COUNT", e.toString()]), (o = !0);
    }
    if (
      (e === h.H.wo &&
        (s.push(["X-Braze-FeatureFlagsRequest", "true"]), (o = !0)),
      o && s.push(["X-Braze-DataRequest", "true"]),
      this.hl.wh())
    ) {
      const t = this.hl.jh();
      null != t && s.push(["X-Braze-Auth-Signature", t]);
    }
    return s;
  }
  Hl(t, e, i, s) {
    if (this.ql[s]) return;
    const r = window.setTimeout(() => {
      E.info(`Retrying rate limited ${this.Rl(s)}SDK request.`),
        this.J(e, i, s);
    }, t);
    this.ql[s] = r;
  }
  fo() {
    for (const t in this.ql) {
      const e = this.ql[t];
      window.clearTimeout(e);
    }
    this.ql = {};
  }
  J(t, e, i, r) {
    if (!this.Ol(i))
      return (
        E.info(`${this.Rl(i)}SDK request being rate limited.`),
        void ("function" == typeof r && r())
      );
    const n = this.Gl();
    if (!n.Wl)
      return (
        this.Hl(n.Yl, t, e, i),
        void E.info(
          `${this.Rl(
            i,
          )}SDK request being rate limited. Request will be retried in ${Math.trunc(
            n.Yl / 1e3,
          )} seconds.`,
        )
      );
    this.B.bt(s.ft.Jl, new Date().valueOf());
    const o = t.device;
    o && o.os_version instanceof Promise
      ? o.os_version.then((i) => {
          (t.device.os_version = i), e(n.Ql);
        })
      : e(n.Ql);
  }
  Vl(t) {
    const e = t ? Ae(t) : null;
    if (!e || !e["retry-after"]) return null;
    const i = e["retry-after"];
    if (isNaN(i) && !isNaN(Date.parse(i)))
      return { type: "date", value: Date.parse(i) };
    if (!isNaN(parseFloat(i.toString())))
      return { type: "timestamp", value: 1e3 * parseFloat(i.toString()) };
    {
      const t =
        "Received unexpected value for retry-after header in /sync response";
      v.lt(f.wl, { e: t + ": " + i });
    }
    return null;
  }
  et(t, e, i, s, r, n) {
    if (h.Ul(this.B, i) >= Zt) return;
    let o;
    n = n || 0;
    const a = this.Vl(t);
    r();
    const u = (t) => {
      const r = window.setTimeout(() => {
        e();
      }, t);
      s(r), h.Zl(this.B, i);
    };
    if (a && !isNaN(a.value)) {
      switch (a.type) {
        case "date":
          (o = a.value - new Date().getTime() + n), o < 0 && e();
          break;
        case "timestamp":
          o = a.value + n;
      }
      u(o);
    } else n ? u(n) : h.fi(this.B, i);
  }
  hc(t) {
    var e;
    null === (e = this.B) || void 0 === e || e.bt(s.ft.uc, t);
  }
  lc(t, e) {
    let i = this.dc();
    null == i && (i = {}), (i[t] = e), this.B.bt(s.ft.fc, i);
  }
  mc() {
    var t;
    return null === (t = this.B) || void 0 === t ? void 0 : t.dt(s.ft.uc);
  }
  dc() {
    var t;
    return null === (t = this.B) || void 0 === t ? void 0 : t.dt(s.ft.fc);
  }
  vc(t, e, i, s, r = "") {
    let n;
    if (r) {
      const t = this.dc();
      n = null == t || isNaN(t[r]) ? e : t[r];
    } else (n = this.mc()), (null == n || isNaN(n)) && (n = e);
    const o = (t - s) / 1e3;
    return (n = Math.min(n + o / i, e)), n;
  }
  Rc(t, e) {
    return Math.max(0, (1 - t) * e * 1e3);
  }
  gc(t, e = "") {
    var i, r, n, o, a;
    const u = { Wl: !0, Ql: -1, Yl: 0 };
    if ((null == t && (t = !0), !t && !e)) return u;
    let l,
      c,
      d = null;
    if (t) d = null === (i = this.B) || void 0 === i ? void 0 : i.dt(s.ft.Jl);
    else {
      const t = h.bc(this.B);
      if (null == t || null == t[e]) return u;
      d = t[e];
    }
    if (null == d || isNaN(d)) return u;
    if (
      (t
        ? ((l =
            (null === (r = this.h) || void 0 === r ? void 0 : r.qc()) || -1),
          (c = (null === (n = this.h) || void 0 === n ? void 0 : n.Ac()) || -1))
        : ((l =
            (null === (o = this.h) || void 0 === o ? void 0 : o.Dc(e)) || -1),
          (c =
            (null === (a = this.h) || void 0 === a ? void 0 : a.Tc(e)) || -1)),
      -1 === l || -1 === c)
    )
      return u;
    const f = new Date().valueOf();
    let m = this.vc(f, l, c, d, e);
    return m < 1
      ? ((u.Wl = !1), (u.Yl = this.Rc(m, c)), u)
      : ((m = Math.trunc(m) - 1),
        (u.Ql = m),
        t ? this.hc(m) : this.lc(e, m),
        u);
  }
  Gl() {
    return this.gc(!0);
  }
  Ol(t) {
    const e = this.gc(!1, t);
    return !(e && !e.Wl);
  }
  Z() {
    this.hl.Z();
  }
  V() {
    return this.al;
  }
  addSdkMetadata(t) {
    for (const e of t) -1 === this.bl.indexOf(e) && this.bl.push(e);
  }
}
